<template>
  <div class="page-box">
    <Header />
    <!-- Banner 区 -->
    <div class="page-content bg-color-EAF1FA">
      <div class="top-box max-width-1920"
        :style="{ backgroundImage: `url(${require('@/assets/product/robot/LM201/banner.jpg')})` }">
        <div class="content-positioning" data-aos="fade-up" :style="contentStype">
          <div class="title-1" :style="titleStyle">AI 健康巡检机器人 LM201</div>
          <div class="title-2">为养老 / 护理 / 医院等 B 端打造<br>
            集智慧医疗、监护与生活服务于一体
            <div class="title-3" @click="openContactUs">
              申请试用
            </div>
          </div>
        </div>

      </div>

      <!-- 核心能力 -->
      <div class="capability-section" data-aos="fade-up">
        <div class="section-title-small">核心技术</div>
        <div class="section-subtitle">三大核心模块 打造健康场景专属智能巡检机器人</div>
        <div class="capability-grid">
          <div class="capability-card" v-for="(item, index) in capabilityList" :key="index">
            <img class="capability-icon" :src="item.icon" alt="">
            <div class="capability-name">{{ item.name }}</div>
            <div class="capability-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>

      <div class="capability-section" data-aos="fade-up">
        <div class="section-title-small">核心卖点</div>
        <div class="section-subtitle">全流程健康服务 覆盖监测、分析、预警、服务全环节</div>
        <div class="capability-grid1">
          <div class="capability-card" v-for="(item, index) in featureList" :key="index">
            <img class="capability-icon" :src="item.icon" alt="">
            <div class="capability-name">{{ item.name }}</div>
            <div class="capability-desc">{{ item.desc }}</div>
          </div>
        </div>
      </div>


      <!-- 技术特点 -->
      <div class="feature-section" data-aos="fade-up"
        :style="{ backgroundImage: `url(${require('@/assets/product/robot/LM201/icon8.jpg')})` }">
      </div>


      <div class="flor3" data-aos="fade-up">
        <div class="f2-title">适配应用场景</div>
        <div class="f2-subtitle">聚焦零售商超领域 适配不同规模零售场景</div>

        <div class="scene-cards-container">
          <div class="scene-card-item" v-for="(scene, index) in sceneList" :key="index">
            <div class="f3-card">
              <img class="bgimg" :src="scene.icon" />
              <div class="title">{{ scene.name }}</div>
              <div class="subtitle">{{ scene.desc }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部联系方式 -->
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import metaInfo from "@/common/util/metaInfo"

export default {
  metaInfo: metaInfo.lm201,
  components: {
    Header,
    Footer
  },
  data() {
    return {
      capabilityList: [
        { icon: require("@/assets/product/robot/LM201/icon1.svg"), name: '健康检测模块', desc: '集成血压、心率、血氧、体温多维度检测，数据准确率 99.5%，一键完成基础健康筛查。' },
        { icon: require("@/assets/product/robot/LM201/icon2.svg"), name: 'AI 健康分析模块', desc: '基于医疗大数据训练，可识别 10+ 类常见健康异常，生成个性化健康建议。' },
        { icon: require("@/assets/product/robot/LM201/icon3.svg"), name: '人机交互模块', desc: '适配老年群体的语音交互，支持方言识别，操作简单无需人工协助。' },
      ],
      featureList: [
        { icon: require("@/assets/product/robot/LM201/icon4.svg"), name: '自助健康检测', desc: '无需专业人员协助，老人自主完成多项健康指标检测，操作仅需 3 步。' },
        { icon: require("@/assets/product/robot/LM201/icon5.svg"), name: '异常智能预警', desc: '检测数据异常时，实时推送至家属/医护人员手机端，3 分钟响应。' },
        { icon: require("@/assets/product/robot/LM201/icon6.svg"), name: '健康档案管理', desc: '自动存储检测数据，生成月度/季度健康报告，支持云端随时查看。' },
        { icon: require("@/assets/product/robot/LM201/icon7.svg"), name: '远程问诊对接', desc: '一键连接社区医生/线上问诊平台，解决老人就医咨询不便问题。' }
      ],
      sceneList: [
        { icon: require("@/assets/product/robot/LM201/icon9.png"), name: '社区养老服务中心', desc: '适配社区老人集中、健康监测需求高频特点，覆盖日常健康筛查全流程，可快速完成多维度指标检测，大幅提升社区健康服务覆盖面与响应速度。' },
        { icon: require("@/assets/product/robot/LM201/icon10.png"), name: '养老机构', desc: '替代人工完成每日健康巡检，减轻护理人员重复性工作负担，标准化健康数据管理，实时预警异常指标，显著提升养老机构整体运营效率。' },
        { icon: require("@/assets/product/robot/LM201/icon11.png"), name: '社区卫生服务站', desc: '补充基础健康检测能力，分流轻症健康咨询需求，让医生聚焦核心诊疗工作，有效提升基层医疗机构接诊效率与服务质量。' },

      ]
    }
  },
  methods: {
    openContactUs() {
      this.$root.$emit('openContactUs', 'LM201')
    }
  }
}
</script>

<style lang="less" scoped>
.page-box {
  background-color: #fff;
}

/* Banner 区域 */
.top-box {
  width: 100%;
  min-width: 1200px;
  height: 600px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  display: flex;
  justify-content: center;
}

.max-width-1920 {
  max-width: 1920px;
  width: 100%;
  padding-top: 70px;
}

.content-positioning {
  width: 1200px;
  text-align: center;
  padding-top: 100px;
}

.title-1 {
  font-weight: bold;
  font-size: 42px;
  color: #222222;
  line-height: 57px;
  letter-spacing: 1px;
  text-align: justify;
}

.title-2 {
  font-size: 24px;
  color: #222222;
  line-height: 42px;
  text-align: justify;
  margin-top: 33px;
}

.title-3 {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: 50px;
  background: linear-gradient(270deg, #29ABFE 0%, #016BFF 100%);
  border-radius: 8px;
  font-weight: bold;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 16px;
  text-align: center;
  cursor: pointer;
}


/* 通用区块样式 */
.section-title {
  font-weight: bold;
  font-size: 32px;
  color: #222222;
  line-height: 34px;
  text-align: center;
  margin-bottom: 40px;
}

.section-title-small {
  font-weight: bold;
  font-size: 32px;
  color: #222222;
  line-height: 34px;
  text-align: center;
  margin-bottom: 10px;
}

.section-subtitle {
  font-size: 16px;
  color: #595859;
  line-height: 21px;
  text-align: center;
}

/* 核心能力 */
.capability-section {
  width: 100%;
  padding: 80px 0;
  background: #ffffff;
}

.capability-grid {
  width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 20px;
  ;
}

.capability-grid1 {
  width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 20px;
  ;
}

.capability-card {
  background: linear-gradient(180deg, #FAFCFF 0%, #ECF2FF 100%);
  border-radius: 6px;
  border: 1px solid #ECF2FF;
  padding: 32px;
  text-align: center;
  transition: all 0.3s;
  flex: 1;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
  }
}

.capability-icon {
  width: 40px;
  height: 40px;
  margin-bottom: 16px;
  object-fit: contain;
}

.capability-name {
  font-size: 20px;
  font-weight: 600;
  color: #222222;
  margin-bottom: 8px;
}

.capability-desc {
  font-size: 14px;
  color: #666666;
  line-height: 22px;
}


/* 技术特点 */
.feature-section {
  width: 100%;
  padding: 80px 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 80vh;
  /* 视窗高度的 80% */
}



.flor3 {
  width: 100%;
  background: #F4F5FB;
  display: flex;
  flex-direction: column;
  padding: 80px 0 80px;

  .f2-title {
    font-weight: bold;
    font-size: 32px;
    color: #222222;
    line-height: 34px;
    text-align: center;
    margin-bottom: 35px;
  }

  .f2-subtitle {
    font-size: 16px;
    color: #222222;
    line-height: 30px;
    text-align: center;
    margin-bottom: 40px;
  }

  .scene-cards-container {
    width: 1200px;
    margin: 0 auto;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  .scene-card-item {
    border-radius: 6px;
    overflow: hidden;
  }

  .f3-card {
    background: #ffffff;
    border-radius: 6px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .f3-card .bgimg {
    width: 100%;
    height: 240px;
    object-fit: cover;
  }

  .f3-card .title {
    font-weight: bold;
    font-size: 22px;
    color: #222222;
    line-height: 22px;
    text-align: left;
    padding: 20px;
    margin: 0;
  }

  .f3-card .subtitle {
    font-size: 14px;
    color: #222222;
    line-height: 22px;
    text-align: justify;
    padding: 0 20px 20px 20px;
    margin: 0;
    flex: 1;
  }

}
</style>
